import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-parallax-quienes',
  templateUrl: './parallax-quienes.component.html',
  styleUrls: ['./parallax-quienes.component.css']
})
export class ParallaxQuienesComponent implements OnInit {

  @Input() ParallaxQuienesSomos_props: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
